import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { TriStateButton, CommonContainer, VFlex } from './styles';

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export default function GetInTouch({ showContact }) {
  return (
    <CommonContainer>
      <VFlex>
        <strong>Get In Touch</strong>
        <small>Contact our team to find out more.</small>
      </VFlex>
      <Wrapper>
        <TriStateButton type="button" pale onClick={showContact}>Contact</TriStateButton>
      </Wrapper>
    </CommonContainer>
  );
}

GetInTouch.propTypes = {
  showContact: PropTypes.func.isRequired,
};
